<template>
  <div class="program-tv__item">
    <div class="program-tv__hour">
      <span class="program-tv__hour-content">
        {{ formatDateToTime(programContext.date_start) }}
      </span>
      <span class="program-tv__continues" v-if="isContinue">Trwa</span>
    </div>
    <a :href="programContext.url" class="program-tv__content-right">
      <div class="program-tv__photo">
        <photo-loader
          :image="programContext.program.image"
          :height-skeletor="sizeRenderHeight"
          :imgWidth="286"
          :imgHeight="161"
        />
      </div>
      <div class="program-tv__description">
        <span v-if="isContinue" class="program-tv__progresbar">
          <span :style="{ width: programProgress + '%' }"></span>
        </span>
        <div class="program-tv__description-content">
          <div class="program-tv__content-text">
            <h2 class="program-tv__description-title">{{ programContext.title }}</h2>
            <span class="program-tv__description-desc">
              {{ programContext.description }}
            </span>
          </div>
          <div class="program-tv__legend-icons">
            <span class="program-tv__legend-icons-sign" title="Język migowy" v-if="isSign"></span>
            <span
              class="program-tv__legend-icons-subbed"
              title="Audycja z napisami"
              v-if="isSubbed"
            >
            </span>
            <span class="program-tv__legend-icons-twelve" v-if="isTwelve"> </span>
            <span class="program-tv__legend-icons-live" v-if="isLive">Na żywo</span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useUtils } from '@/composables/useUtils'
import { useBreakpoint } from '@/composables/useBreakpoints'
import PhotoLoader from '@/components/elements/PhotoLoader.vue'

const { isFullHd, isWidescreen, isDesktop, isTablet, isMobile } = useBreakpoint()

const { formatDateToTime } = useUtils()

const props = defineProps({
  isLive: {
    type: Boolean,
    default: false
  },
  isContinue: {
    type: Boolean,
    default: false
  },
  isSign: {
    type: Boolean,
    default: false
  },
  isSubbed: {
    type: Boolean,
    default: false
  },
  isTwelve: {
    type: Boolean,
    default: false
  },
  programContext: {
    type: Object,
    default: () => ({})
  },
  programProgress: {
    type: [Number, String],
    default: 0
  }
})

const sizeRenderHeight = computed(() =>
  isFullHd.value
    ? '161px'
    : '' || isWidescreen.value
    ? '152px'
    : '' || isDesktop.value
    ? '146px'
    : '' || isTablet.value
    ? '140px'
    : '' || isMobile.value
    ? '158px'
    : ''
)
</script>

<style lang="scss">
@import '@/assets/scss/components/program/program-tv-item.scss';
</style>
